import { SET_SELECTED_DATE, TOGGLE_CALENDAR } from '../../actions/dateSelector';

const initialState = {
  calenderOpen: false,
  date: new Date().toString()
}

const selectedDate = (state = initialState, action) => {
  switch(action.type) {
    case SET_SELECTED_DATE:
      return { ...state, date: action.date.toString() };
    case TOGGLE_CALENDAR:
      return { ...state, calendarOpen: !state.calendarOpen };
    default:
      return state;
  }
}

export default selectedDate;



// WEBPACK FOOTER //
// ./src/reducers/ui/dateSelector.js